import { Routes, Route } from "react-router-dom";
import Snapshot from "./Pages/snapshot";
import Financial from "./Pages/financial";
import Portfolio from "./Pages/portfolio";
import Performance from "./Pages/performance";
import PricePerformance from "./Pages/pricePerformance";
import Login from "./Pages/FileUpload/login";
import RentalIncome from "./Pages/rentalIncome";
import Upload from "./Pages/FileUpload/upload";

function AppRoutes() {
  return (
    <>
      <Routes>
        <Route path="/gorunum" element={<Snapshot />} />
        <Route path="/snapshot" element={<Snapshot />} />
        <Route path="/finansal" element={<Financial />} />
        <Route path="/financial" element={<Financial />} />
        <Route path="/performans" element={<Performance />} />
        <Route path="/performance" element={<Performance />} />
        <Route path="/portfoy" element={<Portfolio />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/fiyatperformans" element={<PricePerformance />} />
        <Route path="/priceperformance" element={<PricePerformance />} />
         <Route path="/rentalincome" element={<RentalIncome />} />
         <Route path="/kirageliri" element={<RentalIncome />} />
        <Route path="/fileuploadlogin" element={<Login />} />
        <Route path="/fileupload" element={<Upload />} />
      </Routes>
    </>
  );
}

export default AppRoutes;
